module.exports = __webpack_public_path__ + "img/gallery-6.5a101abe.jpg";